import { render, staticRenderFns } from "./ContDetail.vue?vue&type=template&id=5537d6bc&scoped=true&"
import script from "./ContDetail.vue?vue&type=script&lang=js&"
export * from "./ContDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContDetail.vue?vue&type=style&index=0&id=5537d6bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5537d6bc",
  null
  
)

export default component.exports